export default __webpack_public_path__ + "static/media/Salesforce-logo.fa3ef509.jpg";